import {Box, Stack, Typography} from '@mui/material';
import {AppointmentBookingEnum, BookingProcessSuccessEnum} from 'main/analytics/gaTagsEnum';
import {ReviewCard} from 'presentation/modules/booking/shared/ui/components/ReviewCard';
import {translations} from 'presentation/translations-new';
import React, {Suspense} from 'react';
import {TelehealthReviewBookingProps} from './types';

import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {ChangeFlowVariantEnum} from 'presentation/modules/booking/shared/ui/components/ChangeFlowDialog/constants';
import {ProviderAddressField} from 'presentation/modules/booking/shared/ui/components/ProviderAddressField';
import {ProviderAddressSkeleton} from 'presentation/modules/booking/shared/ui/components/ProviderAddressField/ProviderAdressSkeleton';
import {SquareLabelTime} from 'presentation/modules/booking/shared/ui/components/SquareLabelTime';
import {TelehealthSummarySectionGroup} from '../../../../components/TelehealthSummarySectionGroup';
import {useTelehealthReviewBooking} from './hooks/useTelehealthReviewBooking';
import {TelehealthConfirmBookingButton} from './components/TelehealthConfirmBookingButton';

const {appointmentSummary} = translations['pt-br'].privateFlow.bookingFlow;
const {professionalAndDate, specialty} = translations['pt-br'].commons;

export function TelehealthReviewBooking({
	handlePrevStep,
	stepLabels,
}: TelehealthReviewBookingProps) {
	const {
		bookingData,
		day,
		month,
		formattedDateAndHour,
		isRebooking,
		handleChangeModals,
		iconName,
		isLaptop,
		isMobile,
		activeBookingFlowStep,
	} = useTelehealthReviewBooking();

	return (
		<Stack
			gap={2}
			m={0}
			data-tag-id={BookingProcessSuccessEnum.ACESSOU_ETAPA_REVISAO_AGENDAMENTO}>
			<Typography variant="subtitle2" color="text.secondary">
				{appointmentSummary}
			</Typography>
			<ReviewCard.Root>
				<ReviewCard.Header
					handleAction={handlePrevStep}
					subheader={professionalAndDate}
					actionDataTagId={AppointmentBookingEnum.CLICK_ALTERAR_INFORMACOES_AGENDAMENTO}
				/>
				<Stack flexDirection={'row'} gap={2} alignItems={'center'}>
					<SquareLabelTime day={day} month={month} />
					<Stack>
						<Typography variant="subtitle2" fontSize={'1.125rem'}>
							{formattedDateAndHour}
						</Typography>
						<ReviewCard.Content
							iconName="medical-services-filled"
							primaryText={bookingData.professionalName}
						/>
					</Stack>
				</Stack>
			</ReviewCard.Root>

			<ReviewCard.Root>
				<ReviewCard.Header
					handleAction={
						isRebooking
							? undefined
							: () => handleChangeModals(ChangeFlowVariantEnum.SPECIALTY)
					}
					subheader={specialty}
					actionDataTagId={AppointmentBookingEnum.CLICK_ALTERAR_INFORMACOES_AGENDAMENTO}
				/>
				<ReviewCard.Content iconName={iconName} primaryText={bookingData.specialtyName} />
			</ReviewCard.Root>

			<Box display={'grid'} gridTemplateColumns={'1fr'} gap={2}>
				<Suspense fallback={<ProviderAddressSkeleton />}>
					<ProviderAddressField flowType={FlowEnum.TELEHEALTH} />
				</Suspense>
			</Box>

			<Stack gap={2}>
				{isLaptop ? (
					<TelehealthSummarySectionGroup
						noBorderRadius={isMobile}
						showTitle={false}
						activeStep={activeBookingFlowStep}
						stepLabels={stepLabels}
						handleChangeModals={handleChangeModals}
					/>
				) : null}

				<TelehealthConfirmBookingButton handleBack={handlePrevStep} />
			</Stack>
		</Stack>
	);
}
